<template>
  <section class="py-9 tablet:py-20">
    <div class="container-wrap">
      <ul class="column-321">
        <li class="tablet:col-span-1">
          <h2 class="text-h2 mb-10 tablet:line-clamp-2">
            {{ title }}
          </h2>
          <TheRichText
            v-if="descriptionHtml || description"
            class="mb-10 w-full text-sm leading-6 text-gray-700 tablet:line-clamp-7 tablet:text-base"
            :text="descriptionHtml || description"
            :is-html="!!descriptionHtml"
          />
        </li>
        <li
          v-for="(item, index) in items"
          :key="hash(item)"
          class="mb-4 tablet:mb-0"
        >
          <CardImage01
            :title="item.name"
            :description="item.description"
            :image-url="item.thumbnail"
            :button-name="item.linkName"
            :button-id="item.trackingCode"
            :button-url="item.link"
            :clickable="true"
            :has-shadow="false"
            @click-callback="emit('click-item', index)"
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
  /**
   * @see https://www.figma.com/design/QJ3ZvEbUHI9xI11iudYf8U/Advantech-WISE-Library?node-id=12927-28001&t=89PIFDiQEC4zcSbf-0
   */

  import hash from 'object-hash';

  interface IItem {
    name: string;
    description: string;
    link: string;
    linkName: string;
    thumbnail: string;
    trackingCode?: string;
  }

  interface IProps {
    title: string;
    description?: string;
    descriptionHtml?: string;
    items: IItem[];
    theme?: TTheme;
  }

  withDefaults(defineProps<IProps>(), {
    description: undefined,
    descriptionHtml: undefined,
    theme: 'blue',
  });

  const emit = defineEmits<{
    (e: 'click-item', index: number): void;
  }>();

  export type { IItem };
</script>
